"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodNotAllowed = void 0;
const ResponseError_1 = require("./ResponseError");
class MethodNotAllowed extends ResponseError_1.ResponseError {
    constructor(message = "Method not allowed error.") {
        super("Method not allowed error.", message, 405);
    }
}
exports.MethodNotAllowed = MethodNotAllowed;
//# sourceMappingURL=MethodNotAllowed.js.map